import React from 'preact/compat';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const PRIMARY_COLOR =
  'var(--mdc-theme-text-hint-on-background,rgba(0,0,0,.38))';

const Animation = styled.svg`
  transform: rotate(${({ active }) => (active ? '90deg' : '0')});
  transition: transform 0.3s;
`;

const SvgIcon = styled(Animation)`
  width:24px;
  height:24px;
`;

const Path = styled.path`
  fill: ${PRIMARY_COLOR}
`;

const Arrow = ({ active }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    active={active}
  >
    <Path
      d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
    />
  </SvgIcon>
);

Arrow.propTypes = {
  active: PropTypes.bool,
};

Arrow.defaultProps = {
  active: false,
};

export default Arrow;
